<template>
  <Modal title="作品评分" v-model="visible">
    <Form ref="userVideoForm" class="form" :model="userVideoParams" :rules="userVideoRules" :label-width="80">
      <Row>
        <Col :span="22">
          <Form-item>
            学生：{{userVideoParams.userId}}-{{userVideoParams.userName}}
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item>
            作品名称：{{userVideoParams.title}}
          </Form-item>
        </Col>
      </Row>
      <Col :span="22">
        <Form-item label="评分" prop="score">
          <Input v-model="userVideoParams.score"/>
        </Form-item>
      </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingEditModal" @click="editUserVideo">提交</Button>
    </div>
  </Modal>
</template>

<script>
  export default {
    name: 'EditUserVideoModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      successCallback: {
        type: Function
      },
      itemId: Number
    },
    data () {
      return {
        visible: this.value,
        userVideoParams: {
          userId: null,
          userName: '',
          title: '',
          score: null
        },
        userVideoRules: {
          score: [
            { type: 'string', required: true, message: '请填写评分', trigger: 'blur' }
          ]
        },
        headers: {},
        loadingEditModal: false,
      }
    },
    methods: {
      editUserVideo () {
        let self = this
        self.loadingEditModal = true
        self.$refs.userVideoForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            return
          }
          self.$http.post('/safenessUserVideo/updateVideo', self.userVideoParams).then(function (res) {
            if (res && res.data > 0) {
              self.visible = false
              self.$Message.success('提交成功!')
              self.successCallback()
              self.loadingEditModal = false
            } else {
              self.$Message.error(res.msg)
            }
          }).catch(function (e) {
            self.visible = false
            self.loadingEditModal = false
          })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === false) {
          this.userVideoParams = {}
          this.videoFileList = []
          this.videoPicFileList = []
          this.$emit('on-close', false)
        }
      },
      itemId (val) {
        if (val) {
          let self = this
          self.$http.get('/safenessUserVideo/queryById?id=' + val).then(function (res) {
            if (res.data) {
              self.userVideoParams.id = res.data.id
              self.userVideoParams.title = res.data.title
              self.userVideoParams.userId = res.data.userId
              self.userVideoParams.userName = res.data.userName
            }
            self.$emit('on-edit-clearid')
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EditUserVideoModal.vue?4f6d9f3e